import { css, styled } from 'styled-components';

import { BUTTON_SIZE } from '@components/button/types';

const colorMixin = ({ $isActive, $isGray }: { $isActive?: boolean; $isGray?: boolean }) => {
	if ($isGray) {
		return css`
			background-color: ${({ theme }) => ($isActive ? theme.colors.control.darkToggle : 'transparent')};
			color: ${({ theme }) => theme.colors.text.alwaysWhite};
		`;
	} else {
		return css`
			background-color: ${({ theme }) => ($isActive ? theme.colors.control.primary : theme.colors.control.dark)};
			color: ${({ theme }) => ($isActive ? theme.colors.text.alwaysDark : theme.colors.text.alwaysWhite)};
		`;
	}
};

const sizeMixin = ({ $size }: { $size: Lowercase<keyof typeof BUTTON_SIZE> }) => {
	if ($size === BUTTON_SIZE.SMALL) {
		return css`
			height: 30px;
			font-size: 12px;
			line-height: 18px;
		`;
	}
	if ($size === BUTTON_SIZE.MEDIUM) {
		return css`
			height: 36px;
			font-size: 14px;
			line-height: 20px;
		`;
	}
	if ($size === BUTTON_SIZE.LARGE) {
		return css`
			height: 42px;
			font-size: 16px;
			line-height: 22px;
		`;
	}
};

export const Wrapper = styled.div<{ $isWide?: boolean; $isRounded?: boolean }>`
	display: flex;
	align-items: center;
	gap: 2px;
	background-color: ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 4px;
	width: fit-content;

	${({ $isWide }) =>
		$isWide &&
		css`
			justify-content: center;
			width: 100%;
		`}

	${({ $isRounded }) =>
		$isRounded &&
		css`
			border-radius: 12px;
		`}
`;

export const Tab = styled.button<{
	$isActive?: boolean;
	$isGray?: boolean;
	$isWide?: boolean;
	$minWidth?: number;
	$size: Lowercase<keyof typeof BUTTON_SIZE>;
	$isRounded?: boolean;
}>`
	text-align: center;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;
	transition: all 0.2s;
	cursor: pointer;
	padding: 9px;

	text-transform: capitalize;

	${({ $isWide, $minWidth }) =>
		$isWide &&
		css`
			min-width: initial;
			flex: 1 1 0;
			padding: unset;
			min-width: ${$minWidth ? `${$minWidth}px` : '90px'};
		`}

	${colorMixin};
	${sizeMixin};

	${({ $isRounded }) =>
		$isRounded
			? css`
					border-radius: 11px;
				`
			: css`
					&:first-child {
						border-radius: 4px 0 0 4px;
					}

					&:last-child {
						border-radius: 0 4px 4px 0;
					}
				`}
`;
